/**
 * Shared presentation helpers for arcade HUD chrome.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { panelTokens } from "@csk/demo-ui";
import type { ArcadeRank } from "./arcadeScoring.js";

/** Color token for the compact rank displayed in arcade HUD strips. */
export function arcadeRankColor(rank: ArcadeRank): string {
  switch (rank) {
    case "S":
      return panelTokens.accentGold;
    case "A":
      return panelTokens.accentGreen;
    case "B":
      return panelTokens.accentBlue;
    case "C":
      return panelTokens.muted;
  }
}
